import React, { useContext } from 'react'
import { BodyContext } from '../../../contexts/BodyProvider'
import useCallRestApi from '../../../hooks/useCallRestApi'
import styles from './adminEditCardBI.module.css'


type Props = {
    cardBI: CardsConectaBI
    handleEditCard: (value: boolean) => void
    handleDeleteCardBI: (value:number, value2: string) => void
}

const AdminEditCardBI = ({cardBI, handleEditCard, handleDeleteCardBI}: Props) => {
  const [callRestApi] = useCallRestApi();
  const { modalCardValue } = useContext(BodyContext);

  const handleEditCardBI = async (id: number) => {
    const link: ResourceLink = {
      href: `api/card_bi/${id}`,
      rel: "search",
      type: "GET",
    };
    try{
      await callRestApi<CardsConectaBI>({
          link,
          onSuccess: (card: CardsConectaBI) => {
            modalCardValue?.setModalCard(card)
            handleEditCard(true)
          },
          onError: (err: ErrorApi) => {},
          onFinally: () => {},
      });
    }catch(error){
      console.log(error)
    }
  }

  return (
    <div className={styles.container_edit_card_bi} style={{backgroundColor: `${cardBI.color}`}}>
        <div className={styles.card_edit_bi_img_title}>
            <img src={cardBI.icon} height={30} width={30} />
            <h5>{cardBI.title}</h5>
        </div>
        <div className={styles.card_edit_bi_icons}>
            <i className="bi bi-pencil-fill" style={{fontSize:'22px', cursor:"pointer"}} onClick={()=>handleEditCardBI(cardBI.id)}></i>
            <i className="bi bi-trash-fill" style={{fontSize:'22px', cursor:"pointer"}} onClick={()=>handleDeleteCardBI(cardBI.id, cardBI.title)}></i>
        </div>
    </div>
  )
}

export default AdminEditCardBI